// Cuánto dura un video, leyendo sólo sus metadatos desde una URL (no lo descarga entero).
// Lo usa Redes para un video de referencia cuya fila no guarda la duración (Animar imagen,
// plantillas, Corregir voz) — ADR-2026-10-05-bloqueos-del-video-de-referencia. Nunca tira:
// 0 = no se pudo saber (red, formato, o tardó más que `esperaMs`).

export function medirDuracionDeVideo(url: string, esperaMs = 6_000): Promise<number> {
  return new Promise((resolver) => {
    if (typeof document === 'undefined') {
      resolver(0);
      return;
    }
    const video = document.createElement('video');
    let listo = false;
    const terminar = (segundos: number) => {
      if (listo) return;
      listo = true;
      window.clearTimeout(reloj);
      video.removeAttribute('src');
      try {
        video.load();
      } catch {
        /* noop */
      }
      resolver(Number.isFinite(segundos) && segundos > 0 ? segundos : 0);
    };
    const reloj = window.setTimeout(() => terminar(0), esperaMs);
    video.preload = 'metadata';
    video.muted = true;
    video.onloadedmetadata = () => terminar(video.duration);
    video.onerror = () => terminar(0);
    video.src = url;
  });
}
